var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRssSquare = function SvgRssSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.429 0H2.57A2.57 2.57 0 0 0 0 2.571V21.43A2.57 2.57 0 0 0 2.571 24H21.43A2.57 2.57 0 0 0 24 21.428V2.572A2.57 2.57 0 0 0 21.428 0M6 20.571a2.571 2.571 0 1 1 0-5.142 2.571 2.571 0 0 1 0 5.142m8.44 0H12.6a.613.613 0 0 1-.613-.57 8.574 8.574 0 0 0-7.989-7.988.613.613 0 0 1-.57-.613V9.56c0-.35.293-.63.643-.611 5.922.32 10.66 5.064 10.98 10.98a.61.61 0 0 1-.612.642m5.519 0h-1.84a.614.614 0 0 1-.612-.59c-.3-7.315-6.172-13.188-13.487-13.488a.614.614 0 0 1-.591-.612V4.04c0-.345.286-.624.631-.612 8.99.323 16.19 7.564 16.511 16.511a.61.61 0 0 1-.613.631"
  }))));
};
export default SvgRssSquare;